import React from 'react';
import { apis, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, notification, Space } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { HeartOutlined } from "@ant-design/icons";
var Api = apis.Api;
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { ButtonConfirm } from '../../../../base-react/components/ButtonConfirm';
var CompetitionSource = models.competitions.CompetitionsSource;
import { Loading } from '../../../../base-react/components/Loading';
const { Title, Text } = Typography;
export const EventVoting = () => {
    let { event_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, , canEdit] = useCompetition(event_id);
    const toggleVotingEnabled = async (value, done) => {
        const newItem = {
            ...event,
            competition_voting_enabled: value ? 1 : 0
        };
        await Api.update(`${CompetitionSource.url}/${event === null || event === void 0 ? void 0 : event.competition_id}`, newItem)
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        done();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('voting.title')),
                React.createElement(Text, { type: "secondary" }, _T('voting.extra')))),
        React.createElement(BodyContainer, null, loadingCompetition ? React.createElement(Loading, null) :
            React.createElement(Space, { orientation: "vertical", style: { width: '100%' } }, (event === null || event === void 0 ? void 0 : event.competition_voting_enabled) === 0 ?
                React.createElement(ButtonConfirm, { title: _T('common.activate.title', { name: _T('voting.title').toLowerCase() }), description: _T('common.activate.content', { name: _T('voting.title').toLowerCase() }), onConfirm: (done) => toggleVotingEnabled(true, done), buttonProps: {
                        size: 'large',
                        type: 'primary',
                        icon: React.createElement(HeartOutlined, null),
                        disabled: !canEdit
                    } })
                :
                    React.createElement(ButtonConfirm, { title: _T('common.disable.title', { name: _T('voting.title').toLowerCase() }), description: _T('common.disable.content', { name: _T('voting.title').toLowerCase() }), onConfirm: (done) => toggleVotingEnabled(false, done), buttonProps: {
                            size: 'large',
                            type: 'dashed',
                            icon: React.createElement(HeartOutlined, null),
                            disabled: !canEdit
                        } })))));
};
